<pms-invoice-details [invoiceId]="invoiceId" [isReadOnly]="false" [isTabView]="true"></pms-invoice-details>
